import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import './DemandWritePage.scss'
import HtmlEditor from '../../Components/Commons/HtmlEditor'
import Select from 'react-select'
// import 'react-select/dist/react-select.css'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import FileItem from '../../Components/Intro/FileItem'
import { RoleStr } from '../../Components/Commons/Utils'

class DemandWritePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            input: {
                title: '',
                content: '',
            },
            files: [],
            chargerGroup: [],
            chargerSelected: {
                value: '',
                label: '',
            },
        }
    }

    UNSAFE_componentWillMount() {
        this.loadProject()
    }

    loadProject = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/projects/${cookies.get('project')}/users/`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                // console.log(res.data)
                const chargerGroup = this.state.chargerGroup

                for (let i = 0; i < res.data.length; i += 1) {
                    if (res.data[i].company && res.data[i].company.name != null && res.data[i].status === 'ENABLED') {
                        chargerGroup.push({
                            value: res.data[i]._id,
                            label: res.data[i].company.name + ' ' + res.data[i].name,
                        })
                    }
                }

                // console.log(chargerGroup)
                this.setState({ chargerGroup })
                this.loadDemand()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadDemand = () => {
        axios
            .get(`${BACKEND_HOST}/rfis/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)

                const charger = this.state.chargerGroup.filter((data) => data.value === res.data.assignee._id)
                const chargerSelected = this.state.chargerSelected
                chargerSelected['value'] = charger[0].value
                chargerSelected['label'] = charger[0].label

                this.setState({ input: { title: res.data.title, content: res.data.content }, chargerSelected })
                this.setState({ files: res.data.files })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    modifyDemand = () => {
        if (this.state.input.title === '') {
            alert('제목을 입력해주세요')
            return
        } else if (this.state.input.content === '') {
            alert('내용을 입력해주세요')
            return
        }

        const files = this.state.files
        const finalFiles = files.map((file) => file._id)

        const { cookies } = this.props
        axios
            .patch(
                `${BACKEND_HOST}/rfis/${this.props.match.params.id}`,
                {
                    title: this.state.input.title,
                    content: this.state.input.content,
                    assignee_id: this.state.chargerSelected.value,
                    files: finalFiles,
                },
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                console.log(res.data)
                this.props.history.push(`/demand`)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    handleModelChange = (model) => {
        const input = this.state.input
        input['content'] = model

        this.setState({
            input,
        })
    }

    handleSelect = (chargerSelected) => {
        this.setState({ chargerSelected })
    }

    arrowRenderer = () => {
        return (
            <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
                    <path
                        fill="none"
                        fillRule="evenodd"
                        stroke="#A2A7AE"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.2"
                        d="M10 2L6 6 2 2"
                    />
                </svg>
            </span>
        )
    }

    deleteFile = (item) => {
        let newFiles = ''
        newFiles = this.state.files.filter((data) => data !== item)

        this.setState({
            files: newFiles,
        })
    }

    fileUpload = (e) => {
        e.preventDefault()

        const file = document.querySelector('input[id=file1]').files[0]
        const data = new FormData()
        data.append('file', file)
        data.append('isEnabled', 'false')
        data.append('metadataType', 'RFI_FILE_V1')

        axios
            .post(`${BACKEND_HOST}/files/upload-files`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const newFiles = [...this.state.files, ...res.data]

                this.setState({
                    files: newFiles,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    FileList = (label) => {
        let files = ''
        files = this.state.files

        if (files.length === 0) {
            return (
                <label htmlFor={label} className="no_file_text">
                    파일을 첨부해주세요
                </label>
            )
        } else {
            const List = files.map((item) => {
                return <FileItem item={item} key={item._id} deleteFile={this.deleteFile} />
            })
            return List
        }
    }

    render() {
        console.log(this.state)
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="damand_write_wrap common_detail">
                        <div className="section">
                            <div className="top_wrap">
                                <div className="page_name">요청사항</div>
                                <input
                                    className="title_textarea"
                                    placeholder="제목을 입력하세요!"
                                    type="text"
                                    name="title"
                                    onChange={this.changeData}
                                    value={this.state.input.title}
                                />
                            </div>
                            <div className="file_input_wrap">
                                <div className="file_input">
                                    <div className="file_name">{this.FileList('file1')}</div>
                                    <label htmlFor="file1" className="load_btn">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14">
                                            <path
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#A2A7AE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="1.3"
                                                d="M12.9 6.632l-5.484 5.643a3.512 3.512 0 0 1-5.067 0C.95 10.835.95 8.502 2.35 7.062L7.834 1.42a2.341 2.341 0 0 1 3.377 0c.933.96.933 2.515 0 3.475l-5.49 5.642a1.17 1.17 0 0 1-1.689 0 1.254 1.254 0 0 1 0-1.737L9.1 3.593"
                                            />
                                        </svg>
                                        <p>파일 첨부</p>
                                    </label>
                                    <input id="file1" type="file" onChange={(e) => this.fileUpload(e)} />
                                </div>
                            </div>
                            <HtmlEditor content={this.state.input.content} handleModelChange={this.handleModelChange} />
                            <div className="select_wrap">
                                {/* <label>처리자</label> */}
                                <Select
                                    name="manager"
                                    value={this.state.chargerSelected}
                                    onChange={this.handleSelect}
                                    placeholder=""
                                    arrowRenderer={this.arrowRenderer}
                                    clearable={false}
                                    options={this.state.chargerGroup}
                                />
                            </div>
                            <div className="btn_wrap">
                                <Link to={'/demand/'}>
                                    <div className="cancel_btn">취소</div>
                                </Link>
                                <Link to={'/demand/'} onClick={this.modifyDemand}>
                                    <div className="ok_btn">등록</div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(DemandWritePage)



// WEBPACK FOOTER //
// ./Src/Containers/Demand/DemandWritePage.js